import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { LoadJsService } from '../../load-js/load-js.service';
import { ApiPartnerService } from '../../api/api-partner.service';
import {URLSearchParams} from '@angular/http';
import { first } from 'rxjs/operators';

import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})


export class HeaderComponent implements OnInit {
  @ViewChild("closeModal", {static: false})
  closeModal: ElementRef;
  @ViewChild("target", { static: false })
  target: HTMLElement;
  private _personname = '';

  formPass = this.fb.group({
    // id: [''],
    username: [''],
    email: [''],
    partner: [''],
    role: [''],
    password: [''],
    password2: [''],
    password3: [''],
  })

  itemget: any = [];
  itemupdate: any = [];
  role: any = [];
  user: any = [];
  userdetails: any = [];
  alert_act: any = [];

  alert_failed = false
  alert_success = false
  alert_redirect = false
  confirmation = false
  error = false
  salah = false

  returnUrl: string;
  successreg : string;
  errorreg : string;
  
  constructor( 
    private router: Router,
    private fb: FormBuilder,
    public LoadJs: LoadJsService,
    public partnerService: ApiPartnerService,
    private authenticationService: AuthenticationService) { }

  @Input()
  set personname(personname: string) {
    // console.log(personname);
    this._personname = personname; //(personname && personname.trim()) || '<no personname set>';
  }

  get personname(): string { return this._personname; }

  ngOnInit() {
    this.cekuser()
    this.thisuser()
  }

  clearForm() {
    this.formPass.reset();
  }

  onActionClick(act:any, item: any) {
    this.alert_act = act
    // console.log(id, act)
    if ( act == "get") {

      this.itemget = item
      //console.log(item, this.itemget)
    }
    if ( act == "update") {

      //console.log("update", item)
      this.login()
    }
  }

  hideModel() {
    this.closeModal.nativeElement.click();      
  }

  ismatch() {
    if (this.formPass.value.password2 == this.formPass.value.password3) {
      //console.log("true", this.formPass.value.password2, this.formPass.value.password3)
      this.confirmation=true
    }else{
      //console.log("false", this.formPass.value.password2, this.formPass.value.password3)
      this.confirmation=false
    }
  }

  getinfo() {
    //console.log("wewhw")
  }

  cekuser() {
    const currentUser:any = this.authenticationService.currentUserValue;
     //console.log(currentUser);
    if (currentUser != null) {
          
      if (currentUser.role.roleName) {
          // authorised so return true
          // this.router.navigate(['']);
          this.user = currentUser;
          this.role = currentUser.role.roleName;
          //console.log(this.role);
          // console.log(this.user, "batas", this.role)
      }
      
    }
      
  }

  thisuser() {
    const params = this.user.name ;
    // console.log(params);
    const currentUser = this.authenticationService.currentUserValue;
    // console.log(currentUser);
    const isLoggedIn = currentUser && currentUser.access_token;
    // console.log(isLoggedIn);

    return this.partnerService.GetUser(params).subscribe((output: any) => {
    //  console.log(output);

        this.userdetails = output.data;
        if ( isLoggedIn )
        {
          //console.log('login dong', output.data);
          //console.log(currentUser);
          currentUser.permision =  output.data.permission;
          //console.log(currentUser);
          this.authenticationService.setcurrentUserValue(currentUser);

        }
    })
  }

  logout() {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
  }

  login() {
    const username: any = { 'username': this.userdetails.username  }
    //console.log(username, this.formPass.value)

    let data = {
      'username': username,
      'password': this.formPass.value.password
    }

    this.authenticationService.login(data)
            .pipe(first())
            .subscribe(
                data => {
                      if ( data ) {
                        //console.log("dapet", data, "status->",status)

                        const params = {
                          'username': this.userdetails.username,
                          'password' : this.formPass.value.password3
                        }
                        this.updateUser(params)
                        // this.router.navigate([this.returnUrl]);
                      } else {
                        //console.log("ga dapet", data, "status->",status)
                        // this.router.navigate(['/dashboard']);
                        this.LoadJs.loadScriptProductStb()
                        this.salah = true;
                        setTimeout(()=>{
                          this.salah = false
                        }, 6000);
                        
                        //console.log("gagal")
                        this.LoadJs.loadScriptProductStb()
                        this.alert_failed = true
                        setTimeout(()=>{
                          this.alert_failed = false
                        }, 6000);
                      }
                    
                },
                error => {
                    this.error = true;
                    this.salah = false;
                    //console.log(error);
                });

                // (output: any) => {
                //   console.log(output)
                //   if ( output.status ){
                //     console.log("masuk")
                    
                //         this.router.navigate(['/dashboard']);
                    
                //   } else {
                //     this.LoadJsOrder.loadScriptProductStb()
                //     this.alert_failed = true
                //     setTimeout(()=>{
                //       this.alert_failed = false
                //     }, 6000);
                //   }
                // })

  }

  updateUser(item: any) {
    //console.log("update oi", item)
    
    this.partnerService.PostUpdateuser(item.username, this.formPass.value.password3)
      .subscribe((response: any) => { 
        console.log(item, this.formPass.value)
        // this.ngOnInit()
        if (response.status == true) {
          // console.log(response)

          this.LoadJs.loadScriptProductStb()
          this.alert_success = true
          setTimeout(()=>{
            this.target.scrollIntoView({behavior:"smooth"})
          }, 2000);

          this.successreg = response.data.message;
          setTimeout(()=>{
            this.alert_success = false
          }, 6000);

          this.alert_redirect = true
          setTimeout(()=>{
            this.hideModel()
            this.logout()
          }, 10000);
          this.formPass.reset();
        } else {

          this.LoadJs.loadScriptProductStb()
          this.alert_failed = true;
          
          this.errorreg = response.data.message;
          setTimeout(()=>{
            this.alert_failed = false;
          }, 6000);

        }
        
      }
    );
  }
}
